// extracted by mini-css-extract-plugin
export default {"container":"KpC1Y","square":"eps+x","wide":"_382fi"};